import { FC, JSX, useEffect, useState } from "react";
import "./ChatsFeedbackAnalysis.scss";
import MasterPage from "../../pages/MasterPage/MasterPage";
import PageBase from "../../components/PageBase/PageBase";
import SkeletonTable from "../../components/SkeletonTable/SkeletonTable";
import AppPagination from "../../components/AppPagination/AppPagination";
import { toast } from "react-toastify";
import DropdownMenuTable from "../../components/DropdownMenuTable/DropdownMenuTable";
import { Dropdown } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faEdit,
  faFeed,
  faFileText,
  faTrash,
} from "@fortawesome/free-solid-svg-icons";
import { usePaginate } from "../../providers/PaginateProvider";
import { useChatsFeedbackAnalysis } from "../../providers/Chats/ChatsFeedbackAnalysisProvider";
import { ChatFeedbackAnalysisModel } from "../../models/Chat/ChatFeedbackAnalysisModel";
import { ChatFeedbackStatusEnum } from "../../enums/Chat/ChatFeedbackStatusEnum";
import SidebarChatsFeedbackAnalysisFilter from "../../components/Chats/SidebarChatsFeedbackAnalysisFilter/SidebarChatsFeedbackAnalysisFilter";
import ModalChatsFeedbackAnalysisInsert from "../../components/Chats/ModalChatsFeedbackAnalysisInsert/ModalChatsFeedbackAnalysisInsert";
import { useSidebarFilter } from "../../providers/SidebarFilterProvider";
import moment from "moment";

interface ChatsFeedbackAnalysisProps { }

const ChatsFeedbackAnalysis: FC<ChatsFeedbackAnalysisProps> = () => {
  const [showModalInsert, setShowModalInsert] = useState<boolean>(false);
  const { showSidebarFilter, setShowSidebarFilter } = useSidebarFilter();
  const [vote, setVote] = useState<ChatFeedbackAnalysisModel>({});
  const [viewAnalysis, setViewAnalysis] = useState<boolean>(false);

  const { handlePaginate } = usePaginate();
  const { votes, setParams, params, isLoading, pages, error } =
    useChatsFeedbackAnalysis();

  useEffect(() => {
    setParams({ ...params, filter: { status_id: 1 }, page: 1, perPage: 10, withPaginate: true });
  }, []);

  const handleEdit = (item: any, analysis: boolean) => {
    setVote(item);
    setShowModalInsert(true);
    if (analysis) setViewAnalysis(analysis);
  };

  const handleCloseModal = () => {
    setShowModalInsert(false);
    setViewAnalysis(false);
    setVote({});
  };

  const renderList = (): JSX.Element => {
    return (
      <>
        {votes?.length > 0 ? (
          <>
            {votes.map((x: ChatFeedbackAnalysisModel, key: number) => (
              <tr key={x.vote_id} className="text-sm">
                <td className="text-center w-10">{x.vote_id}</td>
                <td className="w-15">{x?.user_message?.content}</td>
                <td className="w-40">{x?.agent_message?.content}</td>
                <td className="w-10">
                  {moment(x?.user_message?.created_at).format(
                    "DD/MM/YYYY HH:mm:ss"
                  )}
                </td>
                <td className="w-50">{x?.user}</td>
                <td className="text-center">
                  {x?.status?.id ===
                    ChatFeedbackStatusEnum.AGUARDANDO_ANALISE && (
                      <div className="badge badge bg-warning">
                        {x?.status?.name}
                      </div>
                    )}
                  {x?.status?.id ===
                    ChatFeedbackStatusEnum.ANALISE_CONCLUIDA && (
                      <div className="badge badge-success">{x?.status?.name}</div>
                    )}
                  {x?.status?.id === ChatFeedbackStatusEnum.CONCLUIDO && (
                    <div className="badge badge-success">{x?.status?.name}</div>
                  )}
                </td>
                <td className="text-center">
                  <DropdownMenuTable key={key}>
                    {x?.status?.id === 1 && (
                      <Dropdown.Item
                        className="border-radius-md py-2"
                        onClick={() => handleEdit(x, false)}
                      >
                        <FontAwesomeIcon icon={faFileText} className="me-2" />
                        Analisar
                      </Dropdown.Item>
                    )}
                    {x?.status?.id === 2 || x?.status?.id === 3 ? (
                      <Dropdown.Item
                        className="border-radius-md py-2"
                        onClick={() => handleEdit(x, true)}
                      >
                        <FontAwesomeIcon icon={faFileText} className="me-2" />
                        Ver Análise
                      </Dropdown.Item>
                    ) : null}
                  </DropdownMenuTable>
                </td>
              </tr>
            ))}
          </>
        ) : (
          <tr>
            <td colSpan={7} className="text-center text-sm">
              Não há registros
            </td>
          </tr>
        )}
      </>
    );
  };

  const renderContent = (): JSX.Element => {
    return (
      <>
        {!isLoading ? (
          <div>
            <div className="table-responsive">
              <table className="table table-flush m-0 w-100">
                <thead className="thead-light">
                  <tr>
                    <th
                      className="text-uppercase opacity-7 text-center"
                      scope="col"
                    >
                      #
                    </th>
                    <th className="text-uppercase opacity-7" scope="col">
                      Pergunta
                    </th>
                    <th className="text-uppercase opacity-7" scope="col">
                      Resposta
                    </th>
                    <th className="text-uppercase opacity-7" scope="col">
                      Data Pergunta
                    </th>
                    <th className="text-uppercase opacity-7" scope="col">
                      Usuário
                    </th>
                    <th
                      className="text-uppercase opacity-7 text-center"
                      scope="col"
                    >
                      Status
                    </th>
                    <th
                      className="text-uppercase opacity-7 text-center"
                      scope="col"
                    >
                      Ação
                    </th>
                  </tr>
                </thead>
                <tbody>{renderList()}</tbody>
              </table>
            </div>

            {votes?.length > 0 && (
              <div>
                <nav aria-label="...">
                  <AppPagination
                    pages={pages}
                    handlePaginate={handlePaginate}
                    params={params}
                    setParams={setParams}
                    style={{ backgroundColor: "#fff" }}
                  />
                </nav>
              </div>
            )}
          </div>
        ) : (
          <SkeletonTable />
        )}
      </>
    );
  };

  return (
    <MasterPage title="ChatsFeedbackAnalysis" icon="fas fa-file" footerFixed>
      <div
        className="ChatsFeedbackAnalysis"
        data-testid="ChatsFeedbackAnalysis"
      >
        <PageBase
          title="Feedback"
          subtitle="Gerenciamento de Feedbacks"
          handleFilter={() =>
            !!showSidebarFilter
              ? setShowSidebarFilter(false)
              : setShowSidebarFilter(true)
          }
          error={error}
          children={renderContent()}
          hasFilter
        />

        <ModalChatsFeedbackAnalysisInsert
          show={showModalInsert}
          onClose={() => handleCloseModal()}
          vote={vote}
          analysis={viewAnalysis}
        />
      </div>

      <SidebarChatsFeedbackAnalysisFilter />
    </MasterPage>
  );
};

export default ChatsFeedbackAnalysis;
